"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentStatus = exports.MessagingErrorCodesEnum = void 0;
var MessagingErrorCodesEnum;
(function (MessagingErrorCodesEnum) {
    MessagingErrorCodesEnum["MES001"] = "Unable to load messages.";
    MessagingErrorCodesEnum["MES002"] = "Unable to get message";
    MessagingErrorCodesEnum["MES003"] = "Unable to send message";
    MessagingErrorCodesEnum["MES004"] = "Unable to update message status";
    MessagingErrorCodesEnum["MES005"] = "Unable to convert document.";
    MessagingErrorCodesEnum["MES006"] = "Unable to get attachment detail.";
    MessagingErrorCodesEnum["MES007"] = "Unable to get ProviderInfo from ProviderService.";
    MessagingErrorCodesEnum["MES008"] = "Unable to get Cerner Message by Id";
    MessagingErrorCodesEnum["MES009"] = "Unable to post Audit Log";
    MessagingErrorCodesEnum["MES010"] = "Unable to get Historical Message Detail.";
    MessagingErrorCodesEnum["MES011"] = "Unable to update Message status.";
    MessagingErrorCodesEnum["MES012"] = "Unable to get historical messages.";
    MessagingErrorCodesEnum["MES013"] = "Unable to get message list from Cerner.";
    MessagingErrorCodesEnum["MES014"] = "Unable to get message pool data for msg.";
    MessagingErrorCodesEnum["MES015"] = "Unable to upload and scan message attachment.";
    MessagingErrorCodesEnum["MES016"] = "Unable to store message attachment with Cerner.";
    MessagingErrorCodesEnum["MES017"] = "Inconsistency in the number of attachments";
    MessagingErrorCodesEnum["MES018"] = "Size of file cannot be 0 bytes";
    MessagingErrorCodesEnum["MES019"] = "Unable to find the attachment";
    MessagingErrorCodesEnum["MES020"] = "Unable to delete the attachment";
    MessagingErrorCodesEnum["MES021"] = "messageUUID cannot be empty";
    MessagingErrorCodesEnum["MES022"] = "Cannot attach more than 5 attachments";
    MessagingErrorCodesEnum["MES023"] = "Extension is not supported";
    MessagingErrorCodesEnum["MES024"] = "Mime type is not supported";
    MessagingErrorCodesEnum["MES025"] = "Special characters in fileName are not allowed";
    MessagingErrorCodesEnum["MES026"] = "Cannot upload more than 1 file";
    MessagingErrorCodesEnum["MES027"] = "Cannot upload file of size > 10 mb";
    MessagingErrorCodesEnum["MES028"] = "Messages Guard Error";
    MessagingErrorCodesEnum["MES029"] = "Attachment Guard Error";
    MessagingErrorCodesEnum["MES030"] = "Error extracting request in interceptor";
    MessagingErrorCodesEnum["MES031"] = "Invalid mhp-gen-patient-id";
    MessagingErrorCodesEnum["MES032"] = "No file attached";
    MessagingErrorCodesEnum["MES033"] = "File must include an extension";
    MessagingErrorCodesEnum["MES034"] = "Whitespace characters in fileName are not allowed";
    MessagingErrorCodesEnum["TER001"] = "Invalid Request Data";
    MessagingErrorCodesEnum["CAR001"] = "Unable to update status from careaware";
    MessagingErrorCodesEnum["CAR002"] = "Unable to get messages from careaware";
    MessagingErrorCodesEnum["CAR003"] = "Unable to get message detail from careaware";
    MessagingErrorCodesEnum["CAR004"] = "Unable to send message from careaware";
})(MessagingErrorCodesEnum || (exports.MessagingErrorCodesEnum = MessagingErrorCodesEnum = {}));
var AttachmentStatus;
(function (AttachmentStatus) {
    AttachmentStatus["PENDING"] = "Getting processed";
    AttachmentStatus["READY"] = "Ready to be uploaded";
})(AttachmentStatus || (exports.AttachmentStatus = AttachmentStatus = {}));
//# sourceMappingURL=messaging-error-code.enum.js.map